import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Eye, ZoomInIcon } from "lucide-react";
import { Button } from "../components/ui/button";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/ui/table";

import { Badge } from "../components/ui/badge";
import { Card, CardContent } from "../components/ui/card";
import { Footer } from "../components/Footer";
import { CompactHeader } from "../components/CompactHeader";

import * as Constants from "../../constants";
import BackLoader from "../../components/backloader";

export default function PrincipalOfficers() {
  const [leadership, setLeadership] = useState([]);
  const [category, setCategory] = useState("Principal Officers");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    onLoadTeam();
  }, []);
  const onLoadTeam = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/cms/team/${category}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setLeadership(data.items);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const leadershipTeam = [
    {
      name: "Mr T.A . Elias",
      title: "Chief Registrar",
      image: `${Constants.baseurl}/assets/landing_images/1.png`,
    },
    {
      name: "Mr. R.O. Davies",
      title: "Deputy Chief Registrar (Special Duties) Ikeja",
      image: `${Constants.baseurl}/assets/landing_images/2.png`,
    },
    {
      name: "Miss I Laguda",
      title: "Court Administrator",
      image: `${Constants.baseurl}/assets/landing_images/3.png`,
    },
    {
      name: "Mr. K. A Sanusi",
      title: "Director of Admin & Human Resource",
      image: `${Constants.baseurl}/assets/landing_images/4.png`,
    },
    {
      name: "Mrs. F.M. Oladogba",
      title: "Head of Accounts",
      image: `${Constants.baseurl}/assets/landing_images/5.png`,
    },
    {
      name: "Mr E Alli",
      title: "Head Legal Services",
      image: `${Constants.baseurl}/assets/landing_images/6.png`,
    },
    {
      name: "Mrs O O Ige",
      title: "Head Public Affairs Unit",
      image: `${Constants.baseurl}/assets/landing_images/7.png`,
    },
    {
      name: "Mr O I Oyekanmi",
      title: "Head Budget & Planning",
      image: `${Constants.baseurl}/assets/landing_images/8.png`,
    },
    {
      name: "Mr K A Oladehinde",
      title: "Head, Internal Audit Section",
      image: `${Constants.baseurl}/assets/landing_images/9.png`,
    },
  ];

  const [searchParams] = useSearchParams();
  const [textSize, setTextSize] = useState("normal");

  const mockResults = [
    {
      id: "1",
      SNo: "1",
      Image: "src/images/alogba.png",
      Name: "The Hon. Justice K.O. Alogba",
      Designation: "Chief Judge",
      Location: "Ikeja",
      NumberofCourts: "5",
    },
  ];

  const getFontSizeClass = () => {
    if (textSize === "large") return "text-lg";
    if (textSize === "small") return "text-sm";
    return "text-base";
  };

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <CompactHeader />
      {/* Hero Section */}
      <section className="relative py-24 bg-hero-light-image dark:bg-hero-dark">
        <div className="absolute inset-0 bg-black/5 dark:bg-black/30"></div>

        <div className="container mx-auto px-4 sm:px-6 max-w-7xl relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-gray-900 dark:text-white">
              <div> Principal Officers </div>
              <small>High Court of Lagos State</small>
            </h1>
          </div>
        </div>
      </section>

      {/* Leadership Section */}
      <section
        id="CourtLeadership"
        className="py-20 bg-gray-50 dark:bg-gray-800"
      >
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
          {/* 4 Cards Per Row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
             {leadership.map((leader, index) => (
              <Card
                key={index}
                className="border-0 shadow-lg hover:shadow-xl transition-shadow group"
              >
                <CardContent className="p-6">
                  <div className="aspect-square bg-gradient-to-br from-blue-100 to-blue-200 dark:from-blue-900 dark:to-blue-800 rounded-xl mb-4 overflow-hidden">
                    <img
                       src={`${Constants.docUrl}cms/team/${leader.coverImage}`}
                       alt={leader.fullName}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>

                  <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
                    {leader.fullName}
                  </h3>

                  <p className="text-blue-600 dark:text-blue-400 font-medium mb-3">
                    {leader.position}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
      <Footer />
      <BackLoader open={loading} />
    </div>
  );
}
